/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocalDate } from '../../models/local-date';
import { PageDto } from '../../models/page-dto';
import { SimcardSortColumn } from '../../models/simcard-sort-column';
import { Sorting } from '../../models/sorting';

export interface GetAllSimcards$Params {

/**
 * Filter by the craneId of the router that the simcard is assigned to
 */
  craneId?: string;

/**
 * Filter by expirationDate
 */
  expirationDate?: LocalDate;

/**
 * Filter by the iccid
 */
  iccid?: string;
  page?: number;
  'page-size'?: number;

/**
 * Filter by the routerId the simcard is assigned to
 */
  routerId?: string;

/**
 * The sort direction of the list
 */
  sort?: Sorting & any;

/**
 * The sorting of the result entries
 */
  'sort-column'?: SimcardSortColumn & any;
}

export function getAllSimcards(http: HttpClient, rootUrl: string, params?: GetAllSimcards$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDto>> {
  const rb = new RequestBuilder(rootUrl, getAllSimcards.PATH, 'get');
  if (params) {
    rb.query('craneId', params.craneId, {});
    rb.query('expirationDate', params.expirationDate, {});
    rb.query('iccid', params.iccid, {});
    rb.query('page', params.page, {});
    rb.query('page-size', params['page-size'], {});
    rb.query('routerId', params.routerId, {});
    rb.query('sort', params.sort, {});
    rb.query('sort-column', params['sort-column'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageDto>;
    })
  );
}

getAllSimcards.PATH = '/sim';
